<template>
  <div class="home page-container" >
    <b2bHome v-if="this.business === true" />
    <b2cHome v-else/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import b2cHome from './b2cHome';
import b2bHome from './b2bHome';

export default {
  name: "home",
  components: {
    b2cHome,
    b2bHome,
  },
  metaInfo() {
    return {
      title: `Asian Food & Grocery Store | Chinese Groceries | Asian Snacks Candy`,
      meta: [
        { name: 'description', content: `Asian & Chinese Groceries: Asian Food Grocer offers a huge selection of unique Asian goods, Asian Snacks, Asian Candy, Chinese Snacks, Japanese Snacks, Japanese Candy, Chinese Candy, including food, candy, beverages, household items, and more!` },
        { name: 'keywords', content: "Asian goods, Asian Snacks, Asian Candy, Chinese Snacks, Japanese Snacks, Japanese Candy, Chinese Candy" },
        { name: 'robots', content: "index,follow" }
      ]
    }
  },
  computed: mapState ({
    business: state => state.auth.userDetails.IsBusiness,
  }),
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
  },
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/home.less";
</style>




// WEBPACK FOOTER //
// src/view/Home/home.vue